// extracted by css-extract-rspack-plugin
export default {"content":"content-TBpQnj","header":"header-lkhUB_","muted":"muted-BFIvG8","scrollArea":"scrollArea-aBVzaq","stickySurface":"stickySurface-HiMsGb"};